var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZivistandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zivilstand-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(16.000000, 18.000000)",
    stroke: "#263238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7175866,24.9756098 C19.7175866,21.0320924 16.0205392,17.0885751 9.85879332,17.0885751 C3.6970475,17.0885751 0,21.0320924 0,24.9756098",
    id: "Path",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5481386,19.4985024 C30.8672321,18.7682214 29.8381313,18.4030809 28.4608364,18.4030809 C24.3209876,18.4030809 22.3465982,21.6893453 22.3465982,24.9756098",
    id: "Path-Copy",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(26.947368, 21.689345) scale(-1, 1) translate(-26.947368, -21.689345) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.85879332,
    cy: 7.22978177,
    r: 7.22978177
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 24.9756098,
    cy: 10.5160462,
    r: 5.25802311
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    strokeWidth: 2,
    cx: 9.85879332,
    cy: 7.22978177,
    r: 6.22978177
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    strokeWidth: 2,
    cx: 24.9756098,
    cy: 10.5160462,
    r: 4.25802311
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZivistandIcon);
export default __webpack_public_path__ + "static/media/zivistand-icon.4b7c82cf.svg";
export { ForwardRef as ReactComponent };